import axios from "axios";
import { FETCH_ALL_COUNTER_API } from "../Constants/Apis";

export const getCounters = async () => {
  try {
    return axios.get(FETCH_ALL_COUNTER_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createCounter = async (payload) => {
  try {
    return axios.post(FETCH_ALL_COUNTER_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateCounter = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_COUNTER_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteCounter = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_COUNTER_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};
